import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},[_c(VRow,[_c(VFooter,{staticClass:"transparent"},[_c(VCardText,[_c('a',{staticClass:"white--text",attrs:{"href":"www.sofsolution.com"}},[_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v("Sofsolution")])])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }